import React from "react";

export interface IProps {
  topNav: React.ReactElement;
  sidebar: React.ReactElement;
  pageView: React.ReactElement;
}

const ThreePieceLayout = ({ topNav, sidebar, pageView }: IProps) => (
  <div>
    {topNav}
    <div className="cw-flex cw-flex-[1_1_100%] cw-box-border cw-h-[calc(100vh-72px)]">
      {sidebar}
      <div className="cw-flex cw-justify-center cw-flex-[1_1_100%] cw-overflow-auto">
        {pageView}
      </div>
    </div>
  </div>
);

export default ThreePieceLayout;
